"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupInputDetection = setupInputDetection;
function setupInputDetection() {
    const mq = (query) => window.matchMedia(query).matches;
    // --- Capability snapshot
    const capability = {
        touch: navigator.maxTouchPoints > 0 || mq('(any-pointer: coarse)'),
        mouse: mq('(any-pointer: fine)'),
        primary: mq('(pointer: coarse)') ? 'touch' : mq('(pointer: fine)') ? 'mouse' : 'unknown',
    };
    let lastTouchTime = 0;
    let currentInput = null;
    const setInput = (type) => {
        if (currentInput === type)
            return;
        currentInput = type;
        document.documentElement.dataset.input = type;
    };
    // --- Interaction detection
    window.addEventListener('touchstart', () => {
        lastTouchTime = Date.now();
        setInput('touch');
    }, { passive: true });
    window.addEventListener('mousemove', () => {
        // Ignore fake mouse events after touch
        if (Date.now() - lastTouchTime < 500)
            return;
        setInput('mouse');
    });
    window.addEventListener('keydown', () => {
        setInput('keyboard');
    });
    // --- Initial guess
    if (capability.primary !== 'unknown') {
        setInput(capability.primary);
    }
    return {
        capability,
        getCurrentInput: () => currentInput,
    };
}
